
    import '/home/ec2-user/Youlify-Design/components/chips/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["chips-demo-basic"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/chips/index.zh-CN.md?type=demo')
};